import EndorseMemberForm from "../components/endorseMember/main";

const EndorseMember = () => {
  return <EndorseMemberForm />;
};

export default EndorseMember;
